module.exports = __webpack_public_path__ + "static/img/yd-banner1.881351d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-banner1.png
// module id = M+n0
// module chunks = 0